import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';


//import DataItems = require("DataItems");


class _WizardPageBase extends compose(_WidgetBaseSP) {
    //templateString = template;

    private value: any = null;
    private valid: boolean = true;


    private _onGlobalClick(evt: MouseEvent): void {
        
    }

    // Methoden müssen auf vererbten Widgets überdefiniert werden, sonst Warnung:
    getValue(): any {
        alert("missing 'getValue' in control " + this.id);
    }

    setValue(value: any) {
        alert("missing 'setValue' in control " + this.id);
    }

    isValid(): void {
        alert("missing 'isValid' in control " + this.id);
    }

    getSummary(): string {
        alert("missing 'getSummary' in control " + this.id);
        return "? undefined ?";
    }

    private _onChange_Value(value: any) {
        alert("missing 'getSummary' in control " + this.id);
        this.emit("change", value);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.addSubscription("/Global/Click", lang.hitch(this, this._onGlobalClick));

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.PitHelper._structureFormat = "json";

        //// benötigte Methoden prüfen ob verfügbar:
        //let necessaryMethods = [
        //    "getValue",
        //    "setValue",
        //    "isValid",
        //    "getSummary"
        //];

        //for (let methodname of necessaryMethods) {
        //    if (typeof (this[methodname]) != "function") {
        //        alert("missing '" + methodname + "' in control " + this.id);
        //    }
        //}
        

    }
}

export default mdsWidget(_WizardPageBase);